import { Container } from '@components/Container'
import { campaignTypeLabel } from '@interfaces/promotionCampaign/CampaignTypeEnum'
import { CampaignForm } from '../../components/CampaignForm/CampaignForm'
import { CreateCampaignPageProps } from './interface'

export function CreateCampaignPage({
  campaignType,
  initialValues,
  handleSubmit,
  handleLeave,
}: CreateCampaignPageProps) {
  return (
    <Container>
      <CampaignForm
        initialValues={initialValues}
        campaignType={campaignType}
        title={`สร้างแคมเปญ - ${campaignTypeLabel[campaignType]}`}
        handleSubmit={handleSubmit}
        goBackHandle={handleLeave}
      />
    </Container>
  )
}
